"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _logistics = _interopRequireWildcard(require("@/api/logistics"));
var logistics = _logistics;
var _elementUi = require("element-ui");
var _validate = require("@/utils/validate");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultRole = {
  name: '',
  type: 1,
  appoint: 0,
  sort: 0,
  region: [{
    first: 1,
    firstPrice: 0,
    renewal: 0,
    renewalPrice: 0,
    city_ids: [],
    cityId: 0
  }],
  undelivery: 0,
  free: [],
  undelives: {}
};
var kg = '重量（kg）';
var m = '体积（m³）';
var statusMap = [{
  title: '首件',
  title2: '续件',
  title3: '包邮件数'
}, {
  title: "\u9996\u4EF6".concat(kg),
  title2: "\u7EED\u4EF6".concat(kg),
  title3: "\u5305\u90AE".concat(kg)
}, {
  title: "\u9996\u4EF6".concat(m),
  title2: "\u7EED\u4EF6".concat(m),
  title3: "\u5305\u90AE".concat(m)
}];
var _default = exports.default = {
  name: 'CreatTemplates',
  components: {},
  data: function data() {
    return {
      loading: false,
      rules: {
        name: [{
          required: true,
          message: '请输入模板名称',
          trigger: 'blur'
        }],
        free: [{
          type: 'array',
          required: true,
          message: '请至少添加一个区域',
          trigger: 'change'
        }],
        appoint: [{
          required: true,
          message: '请选择包邮方式',
          trigger: 'change'
        }],
        undelivery: [{
          required: true,
          message: '请选择是否指定区域不配送',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择计费方式',
          trigger: 'change'
        }],
        region: [{
          required: true,
          message: '请选择区域运费',
          trigger: 'change'
        }],
        city_ids: [{
          type: 'array',
          required: true,
          message: '请至少选择一个区域',
          trigger: 'change'
        }],
        first: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
        renewal: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
        firstPrice: [{
          required: true,
          message: '请输入运费',
          trigger: 'blur'
        }],
        renewalPrice: [{
          required: true,
          message: '请输入续费',
          trigger: 'blur'
        }]
      },
      nodeKey: 'city_ids',
      props: {
        children: 'child',
        label: 'name',
        value: 'cityId',
        multiple: true
      },
      dialogVisible: false,
      ruleForm: Object.assign({}, defaultRole),
      listLoading: false,
      cityList: [],
      cityListRequest: null,
      expandedCitySelectors: {},
      largeRegionThreshold: 100,
      columns: {
        title: '首件',
        title2: '续件',
        title3: '包邮件数'
      },
      tempId: 0,
      regionNew: [{
        first: 1,
        firstPrice: 0,
        renewal: 0,
        renewalPrice: 0,
        city_ids: [],
        cityId: 0
      }],
      type: 0 // 0添加 1编辑
    };
  },
  methods: {
    openCreate: function openCreate() {
      var _this = this;
      this.dialogVisible = true;
      this.getCityList().catch(function (error) {
        _this.$message.error(error.message || '城市列表获取失败');
      });
    },
    changeAppoint: function changeAppoint() {
      this.listLoading = false;
      var region = _toConsumableArray(this.ruleForm.region);
    },
    changType: function changType(type) {
      this.type = type;
    },
    confirmEdit: function confirmEdit(row, index) {
      row.splice(index, 1);
    },
    popoverHide: function popoverHide() {},
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.expandedCitySelectors = {};
      this.ruleForm = {
        name: '',
        type: 1,
        appoint: 0,
        sort: 0,
        region: [{
          first: 0,
          firstPrice: 0,
          renewal: 0,
          renewalPrice: 0,
          city_ids: [],
          cityId: 0
        }],
        undelivery: 0,
        free: [],
        undelives: {}
      };
      this.columns = Object.assign({}, statusMap[0]);
    },
    changeRegion: function changeRegion(value) {},
    changeRadio: function changeRadio(num) {
      this.columns = Object.assign({}, statusMap[num - 1]);
    },
    // 添加配送区域
    addRegion: function addRegion(region) {
      region.push(Object.assign({}, {
        first: 0,
        firstPrice: 0,
        renewal: 0,
        renewalPrice: 0,
        city_ids: [],
        cityId: ''
      }));
    },
    addFree: function addFree(Free) {
      Free.push(Object.assign({}, {
        number: 1,
        price: 1,
        city_ids: [],
        cityId: ''
      }));
    },
    /**
     * 详情
     * id 模板id
     * appoint true包邮 false不包邮
     **/
    getInfo: function () {
      var _getInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id, appoint) {
        var loadingInstance, _yield$Promise$all, _yield$Promise$all2, info, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.tempId = id;
              loadingInstance = _elementUi.Loading.service({
                fullscreen: true
              });
              _context.p = 1;
              _context.n = 2;
              return Promise.all([logistics.merchantExpressInfo({
                id: id
              }), this.getCityList()]);
            case 2:
              _yield$Promise$all = _context.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
              info = _yield$Promise$all2[0];
              if (info.appoint === 0) info.type = 1;
              if (Number(info.appoint) > 0) {
                if (info.regionList && info.regionList.length > 0) {
                  info.regionList.forEach(function (item) {
                    if (typeof item.title === 'string') {
                      item.title = JSON.parse(item.title);
                    }
                    item.city_ids = item.title;
                  });
                }
                if (info.freeList && info.freeList.length > 0) {
                  info.freeList.forEach(function (item) {
                    if (typeof item.title === 'string') {
                      item.title = JSON.parse(item.title);
                    }
                    item.city_ids = item.title;
                  });
                }
              }
              this.expandedCitySelectors = {};
              this.ruleForm = Object.assign(this.ruleForm, {
                name: info.name,
                type: info.type,
                appoint: info.appoint,
                sort: info.sort,
                region: info.regionList || [],
                // 运费区域
                free: info.freeList || [] // 包邮区域
              });
              this.regionNew = _toConsumableArray(this.ruleForm.region);
              this.columns = Object.assign({}, statusMap[this.ruleForm.type - 1]);
              this.dialogVisible = true;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message.error(_t.message || '获取运费模板详情失败');
            case 4:
              _context.p = 4;
              loadingInstance.close();
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getInfo(_x, _x2) {
        return _getInfo.apply(this, arguments);
      }
      return getInfo;
    }(),
    // 列表
    getCityList: function getCityList() {
      var _this2 = this;
      if (this.cityList.length > 0) {
        return Promise.resolve(this.cityList);
      }
      if (this.cityListRequest) {
        return this.cityListRequest;
      }
      this.cityListRequest = logistics.treeLevel3().then(function (res) {
        _this2.cityList = res || [];
        return _this2.cityList;
      }).finally(function () {
        _this2.cityListRequest = null;
      });
      return this.cityListRequest;
    },
    getCitySelectionCount: function getCitySelectionCount(row) {
      return Array.isArray(row.city_ids) ? row.city_ids.length : 0;
    },
    getCitySelectorKey: function getCitySelectorKey(row) {
      return row.uniqid || row.cityId || row.title;
    },
    shouldDeferCitySelector: function shouldDeferCitySelector(row) {
      var key = this.getCitySelectorKey(row);
      return this.getCitySelectionCount(row) > this.largeRegionThreshold && !this.expandedCitySelectors[key];
    },
    showCitySelector: function showCitySelector(row) {
      this.$set(this.expandedCitySelectors, this.getCitySelectorKey(row), true);
    },
    change: function change(idBox) {
      idBox.map(function (item) {
        var ids = [];
        item.city_ids.map(function (j) {
          j.splice(0, 1);
          ids.push(j[0]);
        });
        item.city_ids = ids;
      });
      return idBox;
    },
    changeOne: function changeOne(idBox) {
      var city_ids = [];
      idBox.map(function (item) {
        item.splice(0, 1);
        city_ids.push(item[0]);
      });
      return city_ids;
    },
    getCityIds: function getCityIds(cityPaths) {
      return cityPaths.filter(function (cityPath) {
        return Array.isArray(cityPath) && cityPath.length > 0;
      }).map(function (cityPath) {
        return cityPath[cityPath.length - 1];
      });
    },
    onsubmit: (0, _validate.Debounce)(function (formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          _this3.listLoading = true;
          var param = {
            appoint: _this3.ruleForm.appoint,
            name: _this3.ruleForm.name,
            sort: _this3.ruleForm.sort,
            type: _this3.ruleForm.type,
            // 配送区域及运费
            shippingTemplatesRegionRequestList: [],
            // 指定包邮设置
            shippingTemplatesFreeRequestList: []
          };
          _this3.ruleForm.region.forEach(function (el, index) {
            el.title = el.city_ids.length > 0 ? JSON.stringify(el.city_ids) : JSON.stringify([[0, 0]]);
            if (el.title === '[[0,0]]') {
              el.cityId = '0';
            } else {
              var ids = _this3.getCityIds(el.city_ids);
              el.cityId = ids.length > 0 ? ids.join(',') : '0';
            }
          });
          param.shippingTemplatesRegionRequestList = _this3.ruleForm.region;
          param.shippingTemplatesRegionRequestList.forEach(function (el, index) {
            _this3.$delete(el, 'city_ids');
          });
          _this3.ruleForm.free.forEach(function (el, index) {
            el.title = el.city_ids.length > 0 ? JSON.stringify(el.city_ids) : JSON.stringify([[0, 0]]);
            if (el.title === '[[0,0]]') {
              el.cityId = '0';
            } else {
              var ids = _this3.getCityIds(el.city_ids);
              el.cityId = ids.length > 0 ? ids.join(',') : '0';
            }
          });
          param.shippingTemplatesFreeRequestList = _this3.ruleForm.free;
          param.shippingTemplatesFreeRequestList.forEach(function (el, index) {
            _this3.$delete(el, 'city_ids');
          });
          if (_this3.ruleForm.appoint === 2) {
            _this3.ruleForm.region.map(function (item, index) {
              _this3.ruleForm.region[0].title = '[[0,0]]';
              _this3.ruleForm.region[0].cityId = '0';
            });
          }
          if (_this3.ruleForm.appoint === 0) {
            _this3.$delete(param, 'shippingTemplatesRegionRequestList');
            _this3.$delete(param, 'shippingTemplatesFreeRequestList');
            _this3.ruleForm.type = 0;
          }
          if (_this3.type === 0) {
            logistics.merchantExpressSave(param).then(function (res) {
              _this3.$message.success('操作成功');
              _this3.$emit('getList');
              setTimeout(function () {
                _this3.handleClose();
              }, 800);
              _this3.loading = false;
            }).catch(function () {
              _this3.loading = false;
            });
          } else {
            logistics.merchantExpressUpdate(param, {
              id: _this3.tempId
            }).then(function (res) {
              _this3.$message.success('操作成功');
              _this3.$emit('getList');
              setTimeout(function () {
                _this3.handleClose();
                _this3.loading = false;
                _this3.listLoading = false;
              }, 500);
            }).catch(function () {
              _this3.loading = false;
              _this3.listLoading = false;
            });
          }
        } else {
          return false;
        }
      });
    }),
    clear: function clear() {
      this.ruleForm.name = '';
      this.ruleForm.sort = 0;
    }
  }
};